/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import filter from 'lodash/filter';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import config from '@config';
import RenderSections from '@ihs/Common/RenderSections';
import WrapLayout from '@ihs/components/Layout/WrapLayout';
import HeadComponent from '@ihs/components/Utility/HeadComponent';

/* Services */
import CommonComponents from '@ihs/Common/CommonComponents';
import Sidebar from '@ihs/components/Navigation/Sidebar';
import TopBannerV2 from '@ihs/sections/TopBannerV2';
import { performRequest } from '@utils/microsites/DatoCMSHelperService';
import {
  getAllPagesQuery,
  getMenuQuery,
  getQuery,
  getWisdomLandingQuery,
} from '@utils/microsites/IHSGqlQueries';

/* Styles */

/**
 *
 * @param {object} pageData
 * @param {object} wisdomData
 * @param lang
 * @param region
 *
 * @returns
 */

const IhsAbout = ({ pageData, wisdomData, region, lang }) => {
  if (pageData?._seoMetaTags) {
    pageData._seoMetaTags.push({
      tag: 'meta',
      content: null,
      attributes: {
        name: 'description',
        content: pageData.summary || pageData.title,
      },
    });
  }

  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
      >
        {' '}
      </HeadComponent>

      <Box as="section" className="container-article" p="0" bgColor="#f8f8f8">
        {pageData?.sidebarParentLink?.submenuItems?.length > 0 && (
          <Box w="100%" maxW="1330px" bg="#fff" mx="auto">
            {pageData.topBanner?.length > 0 && (
              <>
                <TopBannerV2 sectionContent={pageData?.topBanner[0]} />
                <Flex flexDir={{ base: 'column', lg: 'row' }}>
                  <Sidebar menus={pageData?.sidebarParentLink?.submenuItems} />
                  <Box
                    w={{ base: '100%', md: 'auto' }}
                    ml={{ base: 'auto', lg: '50px' }}
                    mr="auto"
                  >
                    {pageData?.body?.map(section => {
                      return (
                        <RenderSections
                          pageData={pageData}
                          section={section}
                          region={region}
                          lang={lang}
                          wisdomData={wisdomData}
                          key={nanoid(4)}
                        />
                      );
                    })}
                  </Box>
                </Flex>
              </>
            )}

            <Box>
              {pageData.fullWidthContentSection?.map(secCon => {
                return (
                  <CommonComponents
                    key={nanoid()}
                    sectionContent={secCon}
                    region={region}
                    language={lang}
                    wisdomData={wisdomData}
                    pageData={pageData}
                  />
                );
              })}
            </Box>
          </Box>
        )}

        {!pageData?.sidebarParentLink?.submenuItems && (
          <>
            {pageData?.body?.map(section => {
              return (
                <RenderSections
                  pageData={pageData}
                  section={section}
                  region={region}
                  lang={lang}
                  wisdomData={wisdomData}
                  key={nanoid(4)}
                />
              );
            })}
          </>
        )}
      </Box>
    </WrapLayout>
  );
};

export async function getStaticPaths() {
  const allPages = await performRequest(getAllPagesQuery(), 'allpages');
  const urlsList = allPages?.allIhsLandingPages?.map(function (url) {
    return {
      params: {
        levelOne: url.urlAlias,
      },
    };
  });

  return {
    paths: urlsList,
    fallback: false,
  };
}

export const getStaticProps = async ({ params: { levelOne } }) => {
  const headerMenuData = await performRequest(
    getMenuQuery('Ihsmainmenu'),
    'Ihsmainmenu'
  );

  let response = { allIhsLandingPages: [] };
  if (levelOne === 'resources') {
    response = await performRequest(
      getWisdomLandingQuery(`${levelOne}`),
      'resources'
    );
  } else {
    response = await performRequest(getQuery(`${levelOne}`), levelOne);
  }
  let pageData = response.allIhsLandingPages[0] || [];
  pageData = JSON.stringify(pageData).replace(
    /https:\/\/www.datocms-assets.com\//g,
    `${config.staticPath}/d/`
  );
  pageData = JSON.parse(pageData);

  let wisdomData = response?.allWisdomContentParents || [];
  if (wisdomData.length) {
    wisdomData.forEach(card => {
      const children = filter(card?.childrens, function (child) {
        return child?.urlAlias[0]?.locale === 'en_IN';
      });
      if (children?.length) {
        card.childrens = children;
      }
    });

    wisdomData = JSON.stringify(wisdomData).replace(
      /https:\/\/www.datocms-assets.com\//g,
      `${config.staticPath}/d/`
    );
    wisdomData = JSON.parse(wisdomData);
  }

  const footerData = await performRequest(
    getMenuQuery('Ihsfooter'),
    'Ihsfooter'
  );

  return {
    props: {
      headerMenuData: headerMenuData || null,
      pageData: pageData || '',
      wisdomData: wisdomData,
      footerData: footerData || null,
      menuType: 'ihs',
    },
  };
};

export default IhsAbout;
